import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardHeader,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import Swal from "sweetalert2";
import Axios from "axios";
import { configuration } from "../appConfig";
import { connect } from "react-redux";
import "./bulkImages.css";
import PlotDentOnExtraImage from "./PlotDentOnImage/PlotDentOnExtraImage";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class ReportImages extends Component {
  state = {
    uploading: false,
    uploadPercent: 0,
    words: {},
    lang: "En",
    selectedFile: "",
    order: {
      vinNumber: "",
      orderNumber: Math.round(Math.random() * 100000000),
      issuedOn: new Date(),
    },
    partDetails: null,
    twoDView: true,
    vinNumber: null,
    vinfolderList: [],
    showTwoDView: true,
    selectedPartInfo: [],
    scanresult: [],
    extTmages: "",
    id: "",
    img: "",
    imgPath: "",
    openModal: false,
    disableUploadBtn: true,
    bulkImages: [],
    extraImages: [],
    base64Images: [], // State to store base64 encoded images
  };
  componentDidMount() {
    const selectedFile = localStorage.getItem("selectedFile");
    this.setState({ vinNumber: selectedFile });
    // this.getData(selectedFile);
    this.vinFolderList();
    this.getAllExtraImages();
    this.getLang();
  }
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    //alert(nextProps.lang+"123")
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }
  loader = () => (
    <div className="Loading">
      <p>Uploading.. </p>
      <p>{this.state.uploadPercent} % </p>
    </div>
  );

  vinFolderList = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");

    const url = configuration.getExtraImages;
    if (partnerId) {
      const response = await Axios.get(
        url + "?vin=" + selectedFile + "&partnerId=" + partnerId
      );
      if (response.data && response.data.length) {
        this.setState({
          vinfolderList: response.data.filter((item => !item.name.includes("Report_"))),
        });
      } else {
        //  alert('Data not available.')
      }

      //console.table(response.data);
    } else {
      this.props.history.push("/login");
    }
  };

  selectFile = (e) => {
    localStorage.setItem("selectedFile", e.target.value);
    this.setState({ selectedFile: e.target.value });
  };

  getAllExtraImages = () => {
    let partnerId = localStorage.getItem("partnerId");
    const selectedVIN = localStorage.getItem("selectedFile");

    const url1 = `${configuration.getExtraImages}?partnerId=${partnerId}&vin=${selectedVIN}&partName=yes`;
    Axios
      .get(url1)
      .then((res) => {
        // if (res && res.data.extraImages && res.data.extraImages.length) {
        //   this.setState({
        //     extraImages: res.data.extraImages
        //   })
        // }
        if (res && res.data.bulkImages && res.data.bulkImages.length) {
          const sortedArray = [...res.data.bulkImages].sort((a, b) => a.order - b.order);
          this.setState({
            // bulkImages : res.data.bulkImages
            bulkImages: sortedArray
          })
        }
      })
      .catch((err) => {
      });
  };

  getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        reject(error);
      };
    });
  };

  capture = async (e) => {
    const { files } = e.target;
    const base64Images = [];

    // Iterate through each file to convert it to base64
    for (let i = 0; i < files.length; i++) {
      const base64 = await this.getBase64(files[i]);
      base64Images.push(base64);
    }

    // Set base64Images in state and enable upload button
    this.setState({
      base64Images: base64Images,
      disableUploadBtn: false
    });
  };

  uploadMultipleImages = () => {
    const { base64Images } = this.state;

    // Check if there are images to upload
    if (!base64Images || base64Images.length === 0) {
      return;
    }

    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const uploadExtraImagesurl = configuration.uploadExtraImages;
    let uploadedImageCount = 0;

    base64Images.forEach((base64, index) => {
      // const mulData = new FormData();
      // mulData.append('img', base64);
      // mulData.append('vin', vin);
      // mulData.append('partnerId', partnerId);
      // mulData.append('partName', this.state.bulkImages.length > 0 ? `bulkImage-${this.state.bulkImages.length + index + 1}` : `bulkImage-${index + 1}`);

      let payload = {
        img: base64,
        vin: vin ,
        partnerId: partnerId,
        partName:  this.state.bulkImages.length > 0 ? `bulkImage-${this.state.bulkImages.length + index + 1}` : `bulkImage-${index + 1}`,
      };

      var config = {
        onUploadProgress: (progressEvent) => {
          var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          this.setState({ uploadPercent: percentCompleted });
        },
      };

      Axios.post(uploadExtraImagesurl, payload, config)
        .then((res) => {
          uploadedImageCount++;
          Toast.fire({
            type: "success",
            title: "Image Uploaded successfully",
          });
          if (uploadedImageCount === base64Images.length) {
            setTimeout(() => {
              window.location.reload(false);
              this.setState({ uploading: false });
            }, 2500);
          }
        })
        .catch((err) => {
          this.setState({ uploading: false });
        });
    });
  };

  // old function to handle submit
  uploadExtraImages = () => {
    this.setState({ uploading: true });
    if (this.state.extTmages.length) {
      var i;
      for (i = 0; i < this.state.extTmages.length; i++) {

        const partnerId = localStorage.getItem("partnerId");
        const vin = localStorage.getItem("selectedFile");
        const data = new FormData();
        data.append("img", this.state.extTmages[i]);
        data.append("vin", vin);
        data.append("partnerId", partnerId);
        const uploadExtraImagesurl = configuration.uploadExtraImages;

        var config = {
          onUploadProgress: (progressEvent) => {
            var percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            this.setState({ uploadPercent: percentCompleted });
          },
        };

        Axios.post(uploadExtraImagesurl, data, config)
          .then((res) => {
            this.setState({ uploading: false });
            Toast.fire({
              type: "success",
              title: "Image Uploaded successfully",
            });
            this.setState({ extTmages: "" });
            window.location.reload(false);
          })
          .catch((err) => {
            this.setState({ uploading: false });
          });
      }
    }
  };

  delete = (imageObj) => {
    const url = configuration.deleteImage;
    Swal.fire({
      text: this.lang("Are you sure you want to delete this image"),
      showCancelButton: true,
      cancelButtonColor: '#c8ced3',
      confirmButtonColor: '#d80707',
      confirmButtonText: this.lang("Yes"),
      cancelButtonText: this.lang("No"),
      allowOutsideClick: false,
    }).then((result) => {
      if (result.value == true) {
        const data = new FormData();
        data.append("id", imageObj.id)
        data.append("part_name", imageObj.part)
        data.append("vin", imageObj.vin)
        data.append("partnerId", localStorage.getItem("partnerId"));
        data.append("is_type", "web_app");
        data.append("is_extara_image", '2');
        // data.append('tblName', 'vinimages');
        Axios.post(url, data)
          .then((res) => {
              Swal.fire('Deleted!', 'Your item has been deleted.', 'success');
              setTimeout(() => {
                window.location.reload(false); // Reload the page after 2 seconds
              }, 2000);
          })
          .catch((err) => {
            Swal.fire(
              'Error!',
              'An error occurred while deleting.',
              'error'
            );
          });
      }
    });
  };

  
  openModal = (row, path) => {
    this.setState({
      openModal: !this.state.openModal,
      img: row.name,
      id: row.id,
      imgPath: path,
    });
  };

  render() {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const {authorized} = this.props.location.state
    const { img, id } = this.state;

    //const dentInfo = scanResult.resultTXT;

    return (
      <div className="animated fadeIn">
        {this.state.uploading && this.loader()}
        <Col xs="12" sm="12">
          <Card className="print_button_card mt-2">
            <CardHeader>
              <div className="container-fluid">
                <div className="row align-items-center p-0">
                  <div className="col-lg-3 col-md-4 col-sm-12 col-12 mt-sm-10">
                    <small> <span>{this.lang("VIN Number")} : </span> {localStorage.getItem("selectedFile")}</small>
                  </div>
                  <div className="col-lg-9 col-md-8 col-sm-12 col-12 mt-sm-10 p-0">
                    <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
                      <div className="input-group-append dropdown">
                        <button
                          disabled={authorized}
                          className="dropdown-toggle btn btn-info"
                          type="button"
                          aria-expanded="false"
                          aria-haspopup="true"
                          aria-label="Dropdown toggle"
                          onClick={(e) => {
                            this.refs.ExtraImage.click();
                          }}
                        >
                          <i className="fa fa-picture-o" /> {this.lang("Select Extra Image")}
                        </button>
                        <input
                          disabled={authorized}
                          type="file"
                          name="image"
                          multiple
                          id="file"
                          ref="ExtraImage"
                          style={{ display: "none" }}
                          onChange={(e) => {
                            this.capture(e);
                            if (e.target.files.length > 0) {
                              // if the images selected then enable btn
                              this.setState({
                                extTmages: e.target.files,
                                disableUploadBtn: false,
                              })
                            }
                          }
                          }
                        />
                        <div
                          className="dropdown-menu"
                          role="menu"
                          aria-hidden="true"
                          data-popper-placement="bottom-start"
                        ></div>
                      </div>
                      <div className="input-group-append dropdown">
                        <button
                          disabled={authorized}
                          className="dropdown-toggle btn"
                          type="button"
                          aria-expanded="false"
                          aria-haspopup="true"
                          aria-label="Dropdown toggle"
                          onClick={(e) => {
                            this.refs.KM.click();
                          }}
                        >
                          <i className="fa fa-tachometer" /> {this.lang("Select KM Stamp")}
                        </button>
                        <input
                          disabled={authorized}
                          type="file"
                          name="image"
                          id="file"
                          ref="KM"
                          style={{ display: "none" }}
                          onChange={(e) =>
                            this.setState({ extTmages: e.target.files })
                          }
                        />
                        <div
                          className="dropdown-menu"
                          role="menu"
                          aria-hidden="true"
                          data-popper-placement="bottom-start"
                        ></div>
                      </div>

                      <button
                        className="btn btn-danger"
                        disabled={(this.state.disableUploadBtn || authorized)}
                        onClick={() => this.uploadMultipleImages()}
                      >
                        <i className="fa fa-upload"></i> {this.lang("Upload")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </CardHeader>
          </Card>
          <div className="qr_list_table_main ">
            <Modal
              isOpen={this.state.openModal}
              toggle={this.toggleLarge}
              className={"modal-xl " + this.props.className}
            >
              <div className="row modal-header">
                Edit {img} {id}
                <Button
                  color="secondary"
                  className="pull-right"
                  onClick={() =>
                    this.setState({
                      openModal: !this.state.openModal,
                    })
                  }
                >
                  X
                </Button>
              </div>

              <ModalBody style={{ overflow: "scroll" }}>
                <PlotDentOnExtraImage
                  part={img}
                  vin={vin}
                  partnerId={partnerId}
                  imgPath={this.state.imgPath}
                  id={id}
                  controls={true}
                  authorized={authorized}
                />
              </ModalBody>
              <ModalFooter>
              </ModalFooter>
            </Modal>

            <div className="row">
              <div className="col-12 col-sm-12 ">
                <div className="card mb-0 bulk-images-wrapper">
                  {/* <div className="card-header">{this.lang("Images")}</div> */}
                  <div className="table-responsive">
                    <table className="table table-bordered mb-0 border-collapse">
                      <thead>
                        <tr>
                          <th className="text-center" style={{ maxWidth: "80px",width:"80px",minWidth:"80px" }}>{this.lang("Sr. No")}</th>
                          <th>{this.lang("Name")}</th>
                          <th>{this.lang("Image")}</th>
                          <th>{this.lang("Comment")}</th>
                          <th className="text-center" style={{ maxWidth: "150px",width:"150px",minWidth:"150px" }}>{this.lang("Delete")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          this.state.extraImages.map((r, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{`${this.lang("pre-Damage")}`} - {i + 1}</td>
                              <td>
                                <div style={{ width: 100 }}>
                                  <img
                                    onClick={() =>
                                      this.openModal(
                                        r,
                                        r.name
                                      )
                                    }
                                    alt={r.part}
                                    style={{ cursor: "pointer" }}
                                    src={
                                      r.name
                                    }
                                    className="imgGd"
                                    width="100%"
                                  />
                                </div>
                              </td>
                              <td>{r.comment}</td>
                              {/* <td>
                                <button
                                  className="badge badge-danger"
                                  onClick={() => {
                                    this.delete(r);
                                  }}
                                >
                                  X
                                </button>
                              </td> */}
                              <td className="bulk-image-action text-center">
                                <button
                                disabled={authorized}
                                  className="btn btn-danger"
                                  onClick={() => {
                                    this.delete(r.id);
                                  }}
                                >
                                  <i className="fa fa-close"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        }
                        {
                          this.state.bulkImages.map((r, i) => (
                            <tr key={i}>
                              <td className="text-center">{i + 1}</td>
                              <td>{`${this.lang("pre-Damage")}`} - 0{i + 1}</td>
                              <td className="bulk-image-table">
                                <div>
                                  <img
                                    onClick={() =>
                                      this.openModal(
                                        r,
                                        r.name
                                      )
                                    }
                                    alt={r.part}
                                    style={{ cursor: "pointer" }}
                                    src={
                                      r.name
                                    }
                                    className="imgGd"
                                    width="100%"
                                  />
                                </div>
                              </td>
                              <td>{r.comment}</td>
                              <td className="bulk-image-action text-center">
                                <button
                                disabled={authorized}
                                  className="btn btn-danger"
                                  onClick={() => {
                                    this.delete(r.id);
                                  }}
                                >
                                  <i className="fa fa-close"></i>
                                </button>
                              </td>
                            </tr>

                          ))
                        }
                        {(this.state.extraImages.length === 0 && this.state.bulkImages.length === 0) &&
                          <tr>
                            <td colSpan="5" className="text-center">{this.lang("Image not found!")}</td>
                          </tr>
                        }
                      </tbody>

                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </div>
    );
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(ReportImages);
//export default Colors;
